import { gsap } from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import ScrollToPlugin from "gsap/dist/ScrollToPlugin";

var $ = jQuery;
$(document).ready(function ($) {
    var screenWidth = $(window).width();
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

    let mm = gsap.matchMedia();
    mm.add("(min-width: 640px)", () => {
        return gsap.to("footer .bottom_section .flex", {
            x: "-100%",
            repeat: -1,
            duration: 20,
            ease: "linear",
        });
    });

    mm.add("(max-width: 639px)", () => {
        return gsap.to("footer .bottom_section .flex", {
            x: "-150%",
            repeat: -1,
            duration: 10,
            ease: "linear",
        });
    });

    gsap.utils.toArray(".blk-case-study .image_div_class").forEach((image) => {
        gsap.to(image, {
            y: "-30%",
            ease: "none",
            scrollTrigger: {
                trigger: image,
                start: "top bottom",
                end: "bottom top",
                scrub: 1,
            }
        });
    });

	/**
	 * Text animation for the page title within .blk-form element.
	 *
	 * This function splits text in the page title, `.page-title h1` into
	 * individual characters, wraps each in a span element and applies a
	 * staggered fade-in animation using GSAP.
	 *
	 * It is important to give `opacity: 1` to $title once it's ready to
	 * render each letter into it.
	 *
	 * @requires jQuery - For DOM manipulation
	 * @requires GSAP - For animation
	 */
    $(function() {
        $('.blk-form .page-title h1').each(function () {
            var $title = $(this);
            var text = $title.text().split('');
            var html = '';
        
            $.each(text, function (i, letter) {
                if (letter === ' ') {
                    html += '<span class="letter-jquery">&nbsp;</span>';
                } else {
                    html += '<span class="letter-jquery">' + letter + '</span>';
                }
            });
        
            $title.html(html);
            $title.css('opacity', '1');
        
            gsap.set($title.find('.letter-jquery'), {
                opacity: 0,
                y: 20,
                display: 'inline-block'
            });
        
            gsap.to($title.find('.letter-jquery'), {
                opacity: 1,
                y: 0,
                duration: 1,
                stagger: 0.05,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: $('.blk-form'),
                    start: "top 60%",
                    end: "top 20%",
                    scrub: true
                }
            });
        });
        
    });

    if (screenWidth > 992) {
        gsapH4();
    } else {
        adjustH4();
    }


    function adjustH4() {
        var $container = $(".blk-content.stick_top_1");
        var $target = $(".blk-content.stick_top_1 .here");

        var mergedText = $container.find("h4").map(function () {
            return $(this).text();
        }).get().join("<div class='break'><br></div><div class='break'><br></div>");

        $target.html("<h4>" + mergedText + "</h4>");

        gsapH4();
    }

    function gsapH4() {
        $(".blk-content.stick_top_1 h4").each(function () {
            var header = $(this);
            var newHtml = "";

            // Iterate over child nodes to keep <br> intact
            header.contents().each(function () {
                if (this.nodeType === 3) {
                    var text = $(this).text().split("");
                    $.each(text, function (i, letter) {
                        newHtml += "<span class='letter'>" + letter + "</span>";
                    });
                } else {
                    newHtml += this.outerHTML;
                }
            });

            header.html(newHtml);

            // GSAP animation
            gsap.to(header.find(".letter"), {
                color: "#4765FF",
                stagger: 2, // Delay per letter
                scrollTrigger: {
                    trigger: header,
                    start: "top 80%",
                    end: "top 20%",
                    scrub: true,
                }
            });
        });
    }


    // Animate .block-label ::before background color on scroll
    gsap.utils.toArray('.block-label').forEach(function(label) {
        gsap.fromTo(label,
            {
                '--label-dot-color': '#4522B5'
            },
            {
                '--label-dot-color': '#6232FE',
                scrollTrigger: {
                    trigger: label,
                    start: 'top 60%',
                    end: 'top 50%',
                    scrub: true
                }
            }
        );
    });
});

